module.exports = __webpack_public_path__ + "img/5.e7a2e883.jpg";